/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
function subscriptionSwapping() {
  let purchase_options = document.querySelectorAll(".purchase_options label");
  for (let i = 0; i < purchase_options.length; i++) {
    let disabled_input = purchase_options[i].getElementsByTagName("input")[0];
    if (!purchase_options[i].classList.contains("active")) {
      disabled_input.disabled = true;
    }else {
      disabled_input.disabled = false;
    }
  }
}

function productSwapping() {
  fetchPrepaidProduct();
}

function purchase_options() {
  // Purchase option script
  let tabHeader = document.getElementsByClassName("purchase_options")[0];
  let payment_options = document.querySelectorAll('.purchase_options .options');
  let tabsPane = tabHeader.getElementsByTagName("label");
  let tabIndicator = document.getElementsByClassName("tab-indicator")[0];
  let month_to_month = document.querySelectorAll(".current_variant input");
  let prepay_accordion_container = document.querySelectorAll(".product-prepay-faq h4.accordion__title")[0];
  let prepay_accordion_svg = document.querySelectorAll(".product-prepay-faq svg")[0];

  let cart_bar_payment_info = document.getElementById("cart_bar_payment_info");
  let sub_payment_info = document.getElementById("sub_payment_info");

  tabIndicator.style.width = `calc(100% / ${payment_options.length}`;
  month_to_month.disabled = true;
  subscriptionSwapping();
  //Product Swapping
  productSwapping();
    
  for(let i=0;i<tabsPane.length;i++){
    tabsPane[i].addEventListener("click",function(e){
      e.preventDefault();
      tabHeader.getElementsByClassName("active")[0].classList.remove("active");
      tabsPane[i].classList.add("active");
      
      tabIndicator.style.left = `calc(calc(100% / ${payment_options.length}) * ${i})`;
      //Subscription Swapping
      subscriptionSwapping();
      // add to cart pricing
      add_to_cart_pricing();
      if (e.target.classList.contains("preaid")) {
        
        if (prepay_accordion_svg) {
        prepay_accordion_svg.classList.remove("prepay_accordion_svg");
        prepay_accordion_container.classList.remove("prepaid-disable");
        }
        month_to_month.disabled = true;

        if (cart_bar_payment_info) {
          cart_bar_payment_info.innerHTML = "PREPAY • PAUSE & SKIP ANYTIME";
        }
        if (sub_payment_info) {
          sub_payment_info.innerHTML = "PAUSE & SKIP ANYTIME";
        }
        //Product Swapping
        productSwapping();
      } else {
        if (prepay_accordion_svg) {
          prepay_accordion_svg.classList.add("prepay_accordion_svg");
          prepay_accordion_container.classList.add("prepaid-disable");
        }

        month_to_month.disabled = false;
        let prepiad_container = document.getElementById("prepiad_container");
        if(prepiad_container) {
          prepiad_container.remove();
        }

        if (prepay_accordion_svg) {
          let accordion_title = document.getElementsByClassName("accordion__title")[0];
          let product_accordion__body = document.getElementsByClassName("product_accordion__body")[0];
  
          accordion_title.classList.remove("is-open");
          product_accordion__body.style.maxHeight = "0px";
        }

        if (cart_bar_payment_info) {
          cart_bar_payment_info.innerHTML = "MONTHLY • CANCEL & SKIP ANYTIME";
        }
        if (sub_payment_info) {
          sub_payment_info.innerHTML = "CANCEL & SKIP ANYTIME";
        }

      }
    }, false);
  }
}

(function() {
  // Add custom code below this line

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
